export default {
  verificationReview: {
    open: '審查驗證',
    title: '驗證此執行',
    description: '您將接受下列未解決的檢查。求解器結果與自動判定不會變更。',
    automated: '自動判定：{{verdict}}',
    convergenceNotMeasured: '此執行未能量測收斂。',
    noEvidence: '此檢查沒有記錄更多依據。',
    confirm: '確認驗證',
    cancel: '取消',
    remove: '移除驗證',
    by: '{{name}} 已審查 · {{time}}',
    stale: '已有較新的執行。請重新整理設計點後再審查。',
    ineligibleVerdict: '自動判定為 {{verdict}} 時無法審查驗證。',
    ineligibleNoUnresolved: '沒有需要確認的未解決求解器檢查。',
    ineligibleMissingVerification:
      '此嘗試沒有自動驗證紀錄，因此無法進行審查者驗證。',
    setupWrongLead: '自動檢查發現設定問題。請修正失敗項目後再重新執行。',
    setupWrongDetails: '查看詳情',
    acceptDesignIntent: '接受為設計意圖',
    askAdvisorAboutSetup: '詢問顧問',
    designIntentPrompt:
      '研究 {{studyId}}、設計點 {{dpId}}（模擬 {{attemptId}}）。自動驗證回報設定錯誤：{{summary}}。請將此視為本執行的設計意圖——確認失敗的設定檢查以便標為已驗證（不變更求解器結果），並說明摩擦力或近壁數值是否仍應視為不可採信。',
    designIntentSessionTitle: '設計意圖 · 設定檢查',
    setupWrongNoReview:
      '設定檢查未通過；核准全部手算關係可將此執行標為已驗證，或修正設定後重新執行。',
    retryMeshYplus:
      '這是近壁網格（y⁺）問題，不是邊界條件設錯。請調整壁面網格（或 y⁺ 目標）後重新執行。',
    yPlusDiagram: {
      aria: '壁面 y⁺ 區間：理想低 Re（小於 5）、本次執行落在的緩衝帶（5–30）、理想壁函數（大於 30）',
      axis: 'y⁺（第一層網格）',
      lowRe: 'y⁺ < 5',
      buffer: 'y⁺ 5–30',
      wallFunction: 'y⁺ > 30',
      ideal: '理想',
      thisRun: '本次執行',
      thisRunFrac: '本次執行 · {{frac}}%',
      caption:
        '綠與藍為適用的近壁處理。紅為緩衝帶——兩種處理都不適用；請將落在此區的壁面面積壓到上限以下。',
    },
    retryFlowType:
      '流動問題類型與此網格不符。請確認內部／外部流動設定後，重新網格或重新執行。',
    retryBoundaryConditions:
      '請核對入口或遠場邊界條件（速度、壓力、自由流）是否符合案例，然後重新執行。',
    retryContinueAfterSetup:
      '修正設定後請繼續或重新執行——此嘗試在可信完成前已停止。',
    retrySetupGeneric: '請修正下方失敗的設定項目，然後重新執行設計點。',
    checkNames: {
      wall_spacing: '壁面 y⁺ 分布',
      wall_spacing_target: '壁面 y⁺ 目標',
      mass_balance: '質量平衡',
      energy_balance: '能量守恆',
      boundary_flux_resolution: '邊界熱流解析度',
      temperature_bounds: '溫度上下限',
      flow_type: '流動問題類型',
      stagnation: '停滯壓力檢查',
      reference_area: '參考面積',
      length_scale: '長度尺度',
      convergence: '收斂',
      thermal_resistance: '熱阻',
      port_vs_wall_closure: '冷媒熱量 (進出口對壁面)',
      part_heat_balance: '各零件熱平衡',
      contacts_expected: '預期接觸',
      contact_area: '接觸面積',
      heat_placement: '各零件自身單元上的熱',
      contact_pressure: '接觸壓力',
      displacement_scale: '位移尺度',
      stress_resolution: '應力解析度',
    },
  },
  handCalc: {
    workspaceViews: '手算檢視',
    resultsTab: '結果',
    relationsTab: '關係式',
    assumptionsTab: '假設',
    aiNote: 'AI 備註',
    savedChecks: '已儲存的關係式檢查',
    checksSummary: '關係式檢查 · 已核准 {{approved}}/{{total}}',
    checksAgentWrittenAside_one: '· {{count}} 個代理撰寫（請在關係式中檢視）',
    checksAgentWrittenAside_other: '· {{count}} 個代理撰寫（請在關係式中檢視）',
    relationApprovalDoesNotVerify:
      '核准關係式檢查不會改變執行狀態。只有在未解決的求解器檢查需要編輯者確認時，才使用「審查驗證」。',
    relationApprovalPromotesVerified:
      '當需要確認設定或未解決的求解器檢查時，核准全部目錄關係式可將此執行標為已驗證。代理撰寫的自由方程式不是核准對象。',
    addedByYou: '由你加入',
    addedByAI: '由 AI 加入',
    addedByUser: '由使用者加入',
    addedByOther: '由 {{name}} 加入',
    reviewed: '使用者已審閱',
    reviewedByYou: '由你審閱',
    reviewedByOther: '由 {{name}} 審閱',
    approvedByYou: '已由你核准',
    approvedByOther: '已由 {{name}} 核准',
    notReviewed: '尚未核准',
    approve: '核准',
    approveProposed: '核准',
    proposedNeedsRelations:
      '代理撰寫的自由方程式（無目錄範本）。請開啟關係式檢視——核准僅適用於目錄範本，此列不會阻擋「已驗證」。',
    clearApproval: '取消核准',
    markReviewed: '標記為已審閱',
    clearReview: '取消審閱',
    agentGenerated: 'AI 產生',
    structuralRelation: '來自模擬與案例資料',
    structuralRelationHelp:
      '此唯讀關係式由已記錄的模擬結果與提交的案例設定建立，並非 AI 引用或新增。',
    referenceSource: {
      runResult: '執行結果',
      mesh: '網格',
      caseInput: '案例輸入',
      wallNoFlow: '壁面，無質量通過',
      derivedBalance: '由收支推導',
      balanceAt: '收支範圍',
      interface: '界面',
      region: '區域',
      typedFor: '為 {{relation}} 手動輸入（{{symbol}}）',
      fluidLibrary: '流體材料庫 · {{material}} · {{property}}',
      reportedOncePerCase: '全案例只回報一次',
    },
    aiMissingCoolantInputs:
      '熱阻只檢查整個模型。流動與對流檢查需要冷卻液物性及路徑長度。',
    aiExplanationGeneric:
      '部分檢查需要更多輸入值或正確的適用範圍。請查看關係式。',
    sourceCopy: {
      netBalance: '流入＋此區域產熱－流出。',
      sourceHeatPathAssumption:
        '假設熱源的全部熱量都從此路徑離開；此執行尚未證實。',
      hottestSolidAssumption: '使用執行結果回報的固體最高溫度。',
      thermalResistanceReference: '整個模型的熱阻定義',
      steadyStateAssumption: '穩態假設：此區域不累積能量。',
      surfaceHeatFluxSameFaceAssumption:
        'Q 與 A 對應同一面，且取自同一最終求解步。',
      surfaceHeatFluxAverageAssumption:
        'A 為量測面面積；此為平均值，不是局部峰值熱通量。',
      surfaceHeatFluxReference: '表面熱通量，面積平均定義',
      dynamicPressureReference: '不可壓縮流動動壓定義',
      pumpingPowerRatioReference: '泵送功率占帶走熱量的比例（體積流量相消）',
      steadyFlowEnergyReference: '單相流穩態流動能量方程',
      massConservationReference:
        'White《流體力學》— 開口處法向速度均勻、密度恆定時的控制體質量守恆',
      steadySinglePhaseAssumption: '穩態單相流，無功、無相變。',
      cpAtInletAssumption: 'c_p 以入口溫度取值。',
      massWeightedRiseAssumption: '溫升為質量加權出口平均減入口溫度。',
      incompressibleReferenceSpeedAssumption: '不可壓縮流動；U 為參考速度。',
      incompressibleSinglePhaseAssumption: '不可壓縮單相流。',
      pressureDropWholeRegionAssumption: 'dp 為整個流體區域的壓降。',
    },
    jumpToRelation: '查看{{region}}的{{quantity}}關係式',
    jumpToEarlierStep: '查看先前的關係式：{{relation}}',
    seeRelation: '查看關係式',
    relationsChip: '關係式',
    relationNotEvaluated: '關係式尚未求值',
    relationError: {
      generic: '無法使用已儲存的數值計算此式。',
      missingValue: '缺少數值：{{symbols}}。',
      invalidSymbol: '{{symbol}} 不屬於此關係式。',
      solveFailed: '無法求解 {{symbol}}。',
      noRealValue: '沒有符合此關係式的 {{symbol}} 實數解。',
    },
    thermalRelation: {
      surface_heat_flux: '表面熱通量',
      convection_heat_rate: '對流熱流率',
      conduction_1d: '一維熱傳導',
      heat_rate_from_rise: '冷卻液帶走的熱量',
      thermal_resistance: '熱阻',
      thermal_resistance_series: '串聯熱阻',
      conduction_resistance: '熱傳導阻抗',
      biot_number: '畢奧數',
      nusselt_number: '紐賽數',
      colburn_j: '科爾伯恩因子',
      exchanger_effectiveness: '熱交換器效能',
      effective_film_coefficient: '等效熱傳係數',
      pumping_power_ratio: '泵送功率比',
      pipe_nusselt_dittus_boelter: 'Dittus–Boelter 管內關聯式',
      axial_stress: '軸向應力',
      shear_stress: '剪應力',
      bearing_stress: '承壓應力',
      net_section_stress: '淨截面應力',
      tearout_stress: '撕裂剪應力',
      eccentric_bending_stress: '偏心彎曲應力',
      yield_factor: '降伏安全係數',
      bolt_separation_load: '螺栓接合分離載荷',
      bolt_clamp_load: '螺栓夾緊力',
      friction_slip_capacity: '摩擦滑移承載力',
      beam_bending_stress: '梁彎曲應力',
      cantilever_deflection: '懸臂梁撓度',
      simply_supported_deflection: '簡支梁撓度',
      axial_extension: '軸向伸長',
      euler_buckling_pinned: '兩端鉸支柱挫屈載荷',
      slenderness_ratio: '細長比',
      beam_first_bending_mode: '梁第一彎曲固有頻率',
      rod_first_axial_mode: '桿件第一軸向固有頻率',
      dynamic_pressure: '動壓',
      reynolds_number: '雷諾數',
      skin_friction_one_seventh: '平板表面摩擦係數',
      friction_velocity: '摩擦速度',
      first_cell_height: '目標 y+ 的第一層網格高度',
      drag_from_coefficient: '由阻力係數求阻力',
      lift_from_coefficient: '由升力係數求升力',
      sphere_drag_schiller_naumann: '球體阻力關聯式',
      thin_airfoil_lift: '薄翼升力',
      sudden_expansion_loss: '突然擴張損失',
      duct_friction_laminar: '層流管道摩擦係數',
      pipe_pressure_drop_laminar: '層流管道壓降',
      pipe_pressure_drop_blasius: '紊流管道壓降（Blasius）',
    },
    thermalRelationNote: {
      thermal_resistance_series: '各部分的截面積相同。',
      biot_number: '小於 0.1 時，可將固體視為均溫。',
      exchanger_effectiveness: '實際熱傳量占理想最大熱傳量的比例。',
      pipe_nusselt_dittus_boelter:
        '此為近似關聯式；適用時請優先使用 Gnielinski 式。',
    },
    calculatedResults: '手算結果',
    simulationResults: '模擬結果',
    simulationAndDerivedResults: '模擬結果與 AI 推導值',
    noMatchingRunValue: '沒有對應的執行值',
    noHandCalcResult: '沒有手算結果',
    moreRunResults: '其他模擬結果',
    uncheckedOutputs: '未檢核的分析結果',
    uncheckedOutputsHelp:
      '分析所報告但尚未由任何關係式檢核的數值。其中有些根本無法用手算檢核——例如最高溫度是場的極值，而非封閉解能產生的量——其餘則是值得補上的缺口。',
    uncheckedOutputsHelpFlow:
      '分析所報告但尚未由任何關係式檢核的數值。其中有些根本無法用手算檢核——例如壁面最大壓力是表面上的極值，而非封閉解能產生的量——其餘則是值得補上的缺口。',
    uncheckedOutputsHelpStructural:
      '分析所報告但尚未由任何關係式檢核的數值。其中有些根本無法用手算檢核——例如最大應力是場的極值，而非封閉解能產生的量——其餘則是值得補上的缺口。',
    uncheckedOutputsHelpOther:
      '分析所報告但尚未由任何關係式檢核的數值。其中有些根本無法用手算檢核，其餘則是值得補上的缺口。',
    uncheckedReason: {
      declaredInput:
        '這是您宣告的輸入，與自身比較必定一致。真正有用的檢查是反過來：從執行結果反解關係式，看分析是否如實套用您宣告的值。',
      noClosedForm: {
        temperature_max:
          '任意幾何上的節點最大值沒有封閉解。最接近的關係式「集總熱容溫度」只給出體平均，且僅在 Bi 0.1 以下成立；若把體平均與熱點比較，正好在峰值值得報告（物體非等溫）時會顯示為不一致。檢查峰值需要執行本身的場，而不是手算。',
        peak_temperature:
          '執行期間（或場上）的峰值沒有封閉解。最接近的關係式「集總熱容溫度」只給出體平均，且僅在 Bi 0.1 以下成立；若把體平均與熱點比較，正好在峰值值得報告時會顯示為不一致。檢查需要執行本身的場，而不是手算。',
        temperature_min:
          '與最高溫度相同，理由也相同：這是場上的極值，不是封閉解能產生的量。',
        temperature_avg:
          '集總熱容溫度才是真正的候選——對 Bi 0.1 以下的物體，其 T(t) 就是體平均——但它發布的結果量是 temperature，沒有關係式的結果量與此相符。重定向屬於後續工作，不是這張表上的一行。',
      },
    },
    declaredInputs: '您設定的輸入',
    backSolveHint: '可反解 {{relation}} 來檢查',
    declaredInputsHelp:
      '您設定的邊界條件與材料性質。與自身比較必定一致，因此不算缺口。真正有用的是反解：解出您所設定的值，看分析是否如實套用。',
    whyNoHandCalc: '為何沒有手算？',
    noHandCalcHelp:
      '這些是模擬回報的數值，但尚未建立獨立的驗算關係式。名稱相同不代表可以直接比較。',
    addHandCalc: '新增手算',
    addHandCalcAgent: 'Agent',
    addHandCalcLabel: '請代理為 {{region}} 的 {{quantity}} 新增手算關係式',
    addHandCalcChatTitle: '手算 · {{quantity}} · {{region}}',
    addHandCalcChatPrompt:
      '請為 {{region}} 的 {{quantity}} 起草一項手算檢查。執行回報為 {{value}} {{unit}}，目前沒有關係式可驗算。請提出合適的關係式（若目錄沒有適用項可提出自由方程式），並在我同意後儲存。請用白話回答；不要使用工具名稱或配線欄位名稱。\n\n{{toolContext}}',
    askRegionHeat: '詢問區域熱量與正負號',
    askRegionHeatAgent: 'Agent',
    askRegionHeatLabel: '請助理說明這些區域熱收支、桑基圖與正負號慣例',
    askRegionHeatTitle: '區域熱量 · 正負號',
    askRegionHeatNoTerms: '未列出項目',
    askRegionHeatNoLedgers: '此頁沒有顯示區域熱收支。',
    askRegionHeatUnknownTerm: '熱流率',
    askRegionHeatCoverageComplete: '邊界皆有回報',
    askRegionHeatCoverageOneSided: '熱只朝一個方向',
    askRegionHeatCoverageIncomplete: '部分邊界缺值',
    askRegionHeatCoverageLegacy: '較舊的部分帳本',
    askRegionHeatCoverageDerived:
      '涵蓋: 未評估 — 平衡由其他項推算出其中一項, 因此此區域因建構而閉合',
    askRegionHeatLedgerLine:
      '- {{region}}（{{coverage}}）：流入 {{inbound}} {{unit}}，流出 {{outbound}} {{unit}}，餘量 {{remainder}} {{unit}}；項目（正值為進入區域）：{{terms}}',
    askRegionLedgerLineNotAssessed:
      '- {{region}}（未評估）：{{lines}} 未回報數值，因此總和只涵蓋部分邊界，不構成收支。{{side}}已回報的項（流入區域為正）：{{terms}}',
    askRegionNotAssessedNoInflow: '沒有回報任何流入。',
    askRegionNotAssessedNoOutflow: '沒有回報任何流出。',
    askRegionHeatPrompt:
      '請說明此頁的區域熱收支與桑基圖。\n\n{{ledgers}}\n\n請說明正負號慣例：正值表示熱進入區域；桑基圖帶寬依這些有號熱率；餘量 = 流入 − 流出；有顯示平均溫差時，加熱／冷卻優先跟溫度。然後說明這些數字對此次執行的意義——已評估的區域中哪些未閉合，以及標為未評估的區域是哪個邊界未回報數值（不要稱其為未閉合）、下一步應檢查什麼。請用白話回答。不要重畫桑基圖，也不要使用工具名稱、涵蓋列舉值或配線欄位名稱。\n\n{{toolContext}}',
    askRegionMass: '詢問區域質量流率與正負號',
    askRegionMassLabel: '請助理說明這些區域質量流率收支與正負號慣例',
    askRegionMassTitle: '區域質量流率 · 正負號',
    askRegionMassNoLedgers: '此頁未顯示任何區域質量流率收支。',
    askRegionMassUnknownTerm: '質量流率',
    askRegionMassCoverageOneSided: '流動只朝一個方向',
    askRegionMassPrompt:
      '請說明此頁的區域質量流率收支。\n\n{{ledgers}}\n\n請說明正負號慣例：正值表示流入區域；餘量 = 流入 − 流出。然後說明這些數字對此次執行的意義——已評估的區域中哪些未閉合，以及標為未評估的區域是哪個開口未回報數值（不要稱其為未閉合）、下一步應檢查什麼。請用白話回答。不要使用工具名稱、涵蓋列舉值或配線欄位名稱。\n\n{{toolContext}}',
    askRelationAgent: 'Agent',
    askRelationEquation: '詢問此方程式',
    askRelationEquationLabel: '請助手說明 {{title}} 的方程式與脈絡',
    askRelationEquationTitle: '關係式方程式 · {{title}}',
    askRelationEquationPrompt:
      '請說明頁面上這個手算關係式。\n\n名稱：{{title}}\n位置：{{scope}}\n類型：{{source}}\n方程式：{{tex}}\n顯示的輸入：{{givens}}\n結果：{{result}}\n\n此方程式在這裡代表什麼、上方數字中各符號對應什麼、有哪些適用限制？請用白話回答。不要逐列重述輸入，不要使用工具名稱或 id，除非我要求否則不要修改關係式。\n\n{{toolContext}}',
    askRelationBacksolve: '詢問反求',
    askRelationBacksolveLabel: '請助手說明反求 {{title}} 是否有助於驗證執行',
    askRelationBacksolveTitle: '反求 · {{title}}',
    askRelationBacksolvePrompt:
      '請建議是否值得把這個手算關係式反過來，以驗證執行。\n\n名稱：{{title}}\n位置：{{scope}}\n方程式：{{tex}}\n目前怎麼算：{{direction}}\n顯示的輸入：{{givens}}\n結果：{{result}}\n比較：{{comparison}}\n\n說明可以改求哪個量，以及那會如何檢查執行或我宣告的輸入。若反過來不值得——例如正向已在允許帶內、沒有有用未知數、或只會重述宣告輸入——請明白說不值得。除非我聽完後要求，否則不要請求或儲存變更。請用白話回答；不要使用工具名稱或配線欄位名稱。\n\n{{toolContext}}',
    askRelationVerdict: '詢問此判定',
    askRelationVerdictLabel: '請助手說明 {{title}} 的判定與假設',
    askRelationVerdictTitle: '關係式判定 · {{title}}',
    askRelationVerdictPrompt:
      '請說明這個手算關係式的判定。\n\n名稱：{{title}}\n位置：{{scope}}\n方程式：{{tex}}\n結果：{{result}}\n比較：{{comparison}}\n假設：{{assumptions}}\n參考：{{reference}}\n核准：{{approval}}\n問題：{{error}}\n\n說明頁面在說什麼——與允許帶一致或不相符、執行尚未證實的假設（例如熱源熱量都由此路徑離開）、以及核准關係式與驗證執行是分開的。說明什麼已確認、什麼未確認，以及一個具體下一步。請用白話回答；不要使用工具名稱或配線欄位名稱。\n\n{{toolContext}}',
    askRelationToolContext:
      '僅供你的工具使用、請勿向我複述：研究 {{studyId}}、設計點 {{dpId}}、執行 {{attemptId}}。若需更多細節，請讀取畫面上設計點的手算紀錄。',
    addHandCalcToolContext:
      '僅供你的工具使用、請勿向我複述：研究 {{studyId}}、設計點 {{dpId}}、執行 {{attemptId}}、待檢查的量 {{factId}}。若需更多細節，請讀取畫面上設計點的手算紀錄。',
    askRelationSourceLibrary: '目錄關係式',
    askRelationSourceOther: '自訂關係式',
    askRelationNoTemplate: '無（自由／結構）',
    askRelationNoGivens: '未顯示',
    askRelationNoComparison: '此卡無比較',
    askRelationNoBand: '未設允許帶',
    askRelationBandPct: '允許 ±{{value}}%',
    askRelationBandUnknown: '帶寬未評分',
    askRelationWithinBand: '在允許帶內',
    askRelationOutsideBand: '在允許帶外',
    askRelationComparisonLine: '差異 {{delta}}（{{band}}；{{within}}）',
    askRelationNoAssumptions: '未列出',
    askRelationNoReference: '無',
    askRelationNoAttach: '此卡無法變更方向',
    askRelationApproved: '已由審核者核准',
    askRelationNotApproved: '尚未核准',
    askRelationNoSolveFor: '未選定未知數',
    askRelationSolvingFor: '求解 {{symbol}}',
    askRelationNoTarget: '無工程師目標值',
    askRelationDirectionForward: '正向——求解方程式本身的答案',
    askRelationDirectionLine: '{{direction}}；{{solveFor}}；持有值 {{target}}',
    askRelationNoError: '無',
    openRelations: '查看關係式',
    noReferenceBand: '未設參考範圍',
    noReferenceBandHelp:
      '此關係式未設定允許差異。藍色只表示有測得差異，不代表通過或失敗。',
    balanceChecks: '區域熱收支檢查',
    balanceChecksHelp:
      '兩個數值都屬於同一區域：進入或在區域內產生的熱量，以及離開的熱量。差值是未計入的熱量，不是測得的熱源或熱匯。',
    balanceChecksHelpMass:
      '兩個數值都屬於同一區域：進入的質量流率，以及離開的質量流率。差值是未計入的流量，不是測得的源或匯。',
    balanceChecksHelpOther:
      '兩個數值都屬於同一區域：進入或在區域內產生的量，以及離開的量。差值是未計入的量，不是測得的源或匯。',
    symbolHelp:
      '在此關係式中，此符號代表{{quantity}}。可選擇模擬數值，或自行輸入。',
    symbolHelpLabel: '{{symbol}} 的意義',
    editInput: '使用自訂數值',
    saveInput: '儲存',
    chooseRunValue: '選擇模擬數值',
    useSourceValue: '使用原始數值',
    chooseSourceValue: '選擇原始數值',
    sourceGroup: {
      run: '來自模擬結果',
      handCalc: '來自手算結果',
    },
    circularReference: '循環引用',
    circularReferenceHelp: '已停用的選項會在關係式之間形成循環引用。',
    catalogueReference: '參考資料',
    reportedIn: '流入總和',
    reportedOut: '流出總和',
    balanceHeating: '加熱',
    balanceCooling: '冷卻',
    balanceDeltaTAvg: 'ΔT<sub>avg</sub>',
    balanceHeatRoleDeltaHelp:
      '有顯示 ΔT_avg 時，加熱／冷卻跟溫度：+ΔT 為加熱（升溫），−ΔT 為冷卻（降溫）。',
    balanceHeatRoleLedgerHelp:
      '此區域沒有 ΔT_avg — 加熱／冷卻跟熱帳本：流入瓦特多於流出為加熱。',
    balanceHeatRoleDeltaVsLedgerHelp:
      '加熱／冷卻跟 ΔT_avg（溫度），不是瓦特欄。區域可以升溫（+ΔT）同時熱量離開——徽章表示溫度變化；總和才是熱帳本。',
    balanceOutflowTo: '→ {{region}}',
    balanceInflowFrom: '← {{region}}',
    balanceSideOrigin: {
      from_run: '執行結果回報',
      agent_cited: 'AI 引用',
      ai: 'AI 推導',
      mixed: '混合：執行結果 + AI',
      balance: '由平衡推算',
      declared: '宣告值',
      other: '非執行結果',
    },
    ledgerTerms_one: '此平衡中的 {{count}} 項',
    ledgerTerms_other: '此平衡中的全部 {{count}} 項',
    ledgerTermsIn_one: '{{count}} 項流入',
    ledgerTermsIn_other: '全部 {{count}} 項流入',
    ledgerTermsOut_one: '{{count}} 項流出',
    ledgerTermsOut_other: '全部 {{count}} 項流出',
    ledgerOneSided:
      '單向：所有項方向相同，沒有任何已建模的路徑將此量帶出（或帶入）。整個餘量皆未計入。',
    ledgerIncomplete_one:
      '未評估：{{lines}} 未回報數值，因此這只是區域部分邊界的總和。缺漏不等於零。',
    ledgerIncomplete_other:
      '未評估：{{count}} 個邊界（{{lines}}）未回報數值，因此這只是區域部分邊界的總和。缺漏不等於零。',
    ledgerLegacy:
      '建立於區域帳本之前：顯示的是各方向最大的單一項，而非區域總和。',
    ledgerDerived:
      '僅因建構而閉合: 平衡由其他項推算出其中一項, 因此此處執行沒有量測到任何可能不一致的值。未評估。',
    ledgerOrigin: {
      solver: '執行結果',
      declared: '宣告值',
      derived: 'AI 推導值',
      agent_cited: 'AI 引用值',
      engineer: '工程師輸入值',
    },
    ledgerAgentCited_one:
      '包含 {{count}} 個 AI 引用項：AI 在執行結果缺值處附上出處填入此數值，並非執行結果。',
    ledgerAgentCited_other:
      '包含 {{count}} 個 AI 引用項：AI 在執行結果缺值處附上出處填入這些數值，並非執行結果。',
    ledgerAgentGroup:
      'AI 建立的群組：此區域包含哪些零件由 AI 選定，因此此平衡是針對 AI 畫出的邊界，而非案例定義的邊界。',
    ledgerAgentReshaped:
      'AI 重新分組：AI 將零件移入或移出此區域，因此其邊界並非案例定義的邊界。',
    runReports: '執行結果',
    assumptions: '前提條件',
    noAssumptions: '此次執行沒有任何式子使用可修改的數值。',
    saving: '儲存中…',
    saved: '已儲存',
    reset: '重設你的編輯',
    model: '整個模型',
    regions: '區域',
    region: '區域',
    relation: '式子',
    runValueUnavailable: '沒有執行結果數值',
    regionsFoot: '介面因兩個區域相接而存在，無法手動建立。',
    filedCount_one: '{{count}} 項',
    filedCount_other: '{{count}} 項',
    filedHere_one: '此處有 {{count}} 個式子',
    filedHere_other: '此處有 {{count}} 個式子',
    noneHere: '此區域尚未有任何式子。請新增一個式子。',
    ungroup: '取消分組',
    removeRejected: '移除遭拒的項目',
    gap: '收支不平衡',
    given: '已知條件',
    step: '步驟 {{position}} / {{total}}',
    result: '結果',
    net: {
      in: '淨流入區域',
      out: '淨流出區域',
    },
    netRateHelp:
      '正值表示控制體積正在獲得此物理量；負值表示正在流失。穩態時，淨率應趨近於零。',
    derivedBalanceWarning:
      '包含由另一個區域平衡推算出的邊界值。此帶符號的圖形總和並非求解器的能量平衡結果。',
    rightClickUnits: '按右鍵可變更顯示單位。',
    proposed: 'Agent 撰寫',
    proposedHelp:
      '目錄中沒有適用於此邊界的式子，因此由 agent 撰寫此式並註明出處。已通過因次檢查，但未經審查，也不會納入報告。',
    compareAgainst: '比較對象',
    band: '±{{value}}%',
    comparisons: '手算與執行結果比較',
    quantity: '物理量',
    calculated: '計算值',
    observed: '執行結果',
    difference: '差異',
    differenceNotAssessed: '未評估',
    differenceNotAssessedHelp:
      '此區域有邊界未回報數值，因此總和只涵蓋部分邊界。在所有邊界都回報之前不顯示差異。',
    bandColumn: '參考範圍',
    relationBandHelp:
      '此關係式設定的允許差異；計算值在執行結果的 ±{{value}}% 內即視為一致。',
    balanceBandHelp:
      '當殘差不超過兩個相對流率中較大者的 1% 時，收支即在 1% 內閉合。正值表示淨流入區域（或系統）；負值表示淨流出。',
    noComparisons: '此次執行沒有可與這些式子比較的結果。',
    loading: '正在讀取此次執行的手算…',
    loadFailed: '無法讀取手算。',
    unavailable: '此次執行沒有手算。',
    noSavedRecord: '此次執行尚未儲存任何手算。',
    retry: '重試',
    editFailed: '此變更被拒絕，未儲存任何內容。下方的計算未變動。',
    markReviewFailed: '無法核准「{{relation}}」。未儲存任何變更。',
    clearReviewFailed: '無法取消「{{relation}}」的核准。未儲存任何變更。',
    editOnAnotherRun:
      '變更已儲存，但此設計點已移至較新的一次執行。請重新開啟以閱讀已儲存的計算。',
    aiDraft: '由 AI 草擬，之後未經編輯。',
    editedBy: '最後由 {{name}} 編輯。',
    editedByYou: '最後由你編輯。',
    draftedOnAnotherRun: '此計算是針對此設計點先前的一次執行所寫。',
    regenerate: '重新產生',
    regenerating: '草擬中…',
    regenerateTooltip:
      '請顧問為此執行重新草擬手算。會取代此處已儲存的目錄式子、假設、手動輸入與比較目標。案例本身的結構性收支保留。',
    regenerateTooltipEdited:
      '請顧問為此執行重新草擬手算。會取代此處已儲存的全部內容——包含你填的數值、目標與分組。案例本身的結構性收支保留。',
    regenerateTitle: '要重新草擬此手算嗎？',
    regenerateWarning:
      'AI 會為這次執行重寫一份手算，畫面上這一份會被取代，且無法回到目前的草稿。',
    regenerateWarningEdited:
      'AI 會為這次執行重寫一份手算。此處已儲存的內容都會被取代，包含你自己填的數值、目標與分組，且無法復原。',
    regenerateKeep: '保留這一份',
    regenerateConfirm: '取代它',
    regenerateFailed: '無法重新草擬手算，下方已儲存的計算未變動。',
    askAssumptionSuggestions: '建議數值',
    askAssumptionSuggestionsLabel: '請助理為這些假設建議數值',
    askAssumptionSuggestionsTitle: '假設數值',
    askAssumptionSuggestionsPrompt:
      '請為下列手算假設建議數值。\n\n目前數值：\n{{facts}}\n\n其中 {{editableCount}} 項可在畫面上輸入。\n\n對每個需要更好數值的可編輯項，依此類執行（流動、共軛傳熱，或 FEA 熱／結構，視開啟的研究而定）的工程判斷提出建議。優先採用已發表的材料庫與第一性原理估計，而非隨意猜測。說明每個建議對其所支援檢查是偏保守還是偏樂觀，以及在此設定下是否物理合理或會不合理。不要杜撰介面欄位名稱。除非我在你說明後要求，否則不要儲存變更。\n\n{{toolContext}}',
    askAssumptionValue: '建議數值',
    askAssumptionValueLabel: '請助理為{{region}}的{{quantity}}建議數值',
    askAssumptionValueTitle: '假設 · {{quantity}} · {{region}}',
    askAssumptionValuePrompt:
      '請為這個手算假設建議數值。\n\n物理量：{{quantity}}\n區域：{{region}}\n目前值：{{value}}\n關係式：{{relation}}\n符號：{{symbol}}\n\n依此類執行（流動、共軛傳熱，或 FEA 熱／結構，視開啟的研究而定）的工程判斷提出數值。優先採用已發表材料庫與第一性原理估計。說明建議對其所支援檢查是偏保守還是偏樂觀，以及在此設定下是否物理合理或會不合理。不要杜撰介面欄位名稱。除非我在你說明後要求，否則不要儲存變更。\n\n{{toolContext}}',
    askAssumptionNoFacts: '尚無列出',
    askAssumptionToolContext:
      '僅供你的工具使用，請勿向我複述：研究 {{studyId}}、設計點 {{dpId}}、嘗試 {{attemptId}}。若需更多細節，請讀取開啟中設計點的手算紀錄。',
    addRelation: '新增式子',
    relationLimit:
      '此手算已有 {{max}} 條式子，已達單一紀錄的上限。請先移除一條再新增。',
    removeRelation: '移除',
    removeRelationLabel: '從此設計點移除 {{name}}',
    confirmRemoveRelation: '確定移除',
    cancelRemoveRelation: '保留',
    catalogue: '式子目錄',
    catalogueCount: '{{total}} 個中有 {{applicable}} 個適用於此',
    chooseRelation: '選擇式子',
    chooseFact: '選擇數值',
    noOffers: '此區域沒有其他適用的式子。',
    optionalResult: '選填 — 指定後可與執行結果比較',
    leaveUnbound: '選填 — 不指定',
    missingBinding: '此次執行沒有此符號所需單位的數值。',
    needsTypedValue: '此次執行沒有 {{symbols}} 的數值。輸入數值即可加入。',
    attach: '加入',
    typeValue: '輸入數值',
    typedHere: '在此輸入，記錄為此區域的{{quantity}}',
    gapQuantity: '{{quantity}}不平衡',
    gapTitle: '流入＋此處宣告的量－流出。負值表示淨流出。',
    changeDirection: '改變求解方向',
    directionTitle: '此式子的求解方向',
    directionHelp:
      '可正向求解，或反向求解並指定答案的來源——執行結果的數值，或你設定的目標值。兩者不可並存。',
    directionForward: '求解式子本身的答案 <sym/>',
    directionBackwards: '反向求解',
    solveFor: '求解對象',
    chooseUnknown: '選擇符號',
    holdFromRun: '將 <sym/> 固定為執行結果的數值',
    useRunValue: '使用執行結果的數值',
    noRunValue: '此次執行沒有可固定 <sym/> 的數值。',
    holdFromTarget: '將 <sym/> 固定為你設定的目標值 [{{unit}}]',
    targetReason: '目標值的依據',
    useTarget: '使用我的目標值',
    unitFor: '{{quantity}} 的單位',
    flowTitle: '熱量的去向',
    flowView: '熱流檢視',
    flowWholeModel: '整體模型',
    flowRegions: '各區域',
    flowWholeScopeHelp:
      '整體模型的收支使用宣告的入熱與外部邊界熱流率；內部熱傳會互相抵消。',
    flowRegionScopeHelp:
      '每個區域以其邊界上的所有項各自計算收支。每個界面只計算一次，因此繪出的區域餘量加總等於整體模型的餘量；在 1% 以內平衡的區域不會繪出。',
    flowRegionSingleBodyHelp:
      '此執行只有一個承熱本體，因此「各區域」與「整體模型」相同。網格有多個體積（或 CHT 區域／介面）且結果帶有面歸屬時，才會出現分本體帶狀圖。',
    flowCaption:
      '圖帶結合案例宣告的輸入熱量與執行結果回報的熱流率（{{unit}}）。橙色是推算的收支差額，並非量測到的熱流。',
    flowSource: '宣告的輸入熱量',
    flowEnvironment: '外部邊界',
    flowMissingIn: '未計入的流入熱量',
    flowMissingOut: '未計入的流出熱量',
    flowMoreLeaves: '流出多於流入及內部產熱',
    flowMoreEnters: '流入及內部產熱多於流出',
    flowNotAssessed: '部分和的餘量：此區域有邊界未回報數值',
    flowLegend: '能量流圖例',
    flowLegendSource: '來源 · 宣告的輸入熱量',
    flowLegendTransfer: '傳遞 · 區域間熱流',
    flowLegendSink: '流出 · 外部邊界',
    flowLegendDerived: 'AI 推導或引用 · 非求解器回報值',
    flowLegendBalanceDerived: '由平衡推算, 非量測',
    flowCitedByAgent: 'AI 附上出處填入；非求解器回報或已審閱數值',
    flowCitedCaution: '部分熱量為 AI 引用值，非求解器量測值。',
    flowDetail: {
      temperature_change: '相對初始溫度的 ΔT<sub>avg</sub>',
      mass_flow: '質量流率 ṁ',
      inlet_temperature: '入口 T<sub>in</sub>',
      inlet_velocity: '入口速度 U<sub>in</sub>',
      outlet_temperature: '出口平均溫度 T<sub>out</sub>',
      outlet_velocity: '出口平均速度 U<sub>out</sub> = ṁ/(ρA)',
    },
    flowDetailEstimated: '由各區域估算',

    flowDerivedByAgent: 'AI 依執行輸入推導；非求解器回報或已審閱數值',
    flowDerivedByBalance: '由平衡推算, 非量測',
    flowDerivedCaution: '邊界熱量由 AI 推導，非求解器量測值。',
    flowBalanceDerivedCaution:
      '灰色帶為執行未回報、由平衡推算出的熱率; 僅靠它們閉合的區域未評估。',
    flowLegendGap: '未計入的流入或流出 · 收支差額，非量測到的熱流',
    flowGapHelp:
      '此區域的流入與流出熱量報告值不同。這條帶表示差額及方向，不是真正的熱源或散熱出口。',
    assumptionEditable: '可編輯假設。使用者或代理可變更此已儲存的手算數值。',
    assumptionReadOnly: '由求解器輸出或由其他已記錄事實推導的唯讀證據。',
    flowEmpty: '此次執行沒有可繪製的數值。',
    flowAwaitingBoundary:
      '案例已宣告輸入熱量，但此次執行未回報入口或出口的熱流率。AI 可編輯手算的假設與關係式，不能改動實測的邊界熱流率，因此尚無法繪出完整路徑。',
    flowUnreportedBoundaries: '未回報熱流率的案例邊界：{{names}}。',
    flowTooltip: '{{label}}：{{value}} {{unit}}',
    flowTable: '以清單檢視流向',
    flowLoop: '未繪製於圖中：流向會回到原本的位置',
    radarTitle: '各式與執行結果的差距',
    radarCaption: '與執行結果的差距（不含正負號），對照各式公布的容許範圍。',
    radarDeviation: '與執行結果的差距',
    radarBand: '公布的容許範圍',
    radarNoBand: '無公布的容許範圍',
    radarTooltip: '{{label}}：與執行結果差 {{value}}%，容許範圍 ±{{band}}%',
    radarTooltipNoBand: '{{label}}：與執行結果差 {{value}}%',
    kind: {
      model: '模型',
      body: '固體',
      fluid: '流體',
      group: '群組',
      line: '邊界',
    },
    kindHelp: {
      model: '整個模型的控制體積——所有固體與流體合在一起。',
      body: '案例中的單一固體零件，不是所有固體的加總。整個模型那一列才是系統收支。',
      fluid:
        '案例中的單一流體區域，不是所有流體的加總。整個模型那一列才是系統收支。',
      group: '將多個零件視為同一個控制體積的命名群組，不是各零件分開列出。',
      line: '網格上的單一邊界或介面。',
    },
    provenance: {
      run: '來自執行結果',
      library: '來自材料庫',
      cited: 'AI 引用',
      engineer: '由工程師輸入',
      engineerNamed: '由 {{name}} 輸入',
      engineerYou: '由你輸入',
      step: '來自前一步驟',
      target: '你的目標值',
    },
    direction: {
      fromRun: '來自執行結果',
      fromTarget: '來自你的目標值',
    },
    op: {
      attach: '式子 {{position}}',
      reparent: '分組 {{position}}',
      value: '數值 {{position}}',
      propose: 'Agent 式子 {{position}}',
    },
    quantityName: {
      area: '面積',
      volume: '體積',
      mass: '質量',
      density: '密度',
      kinematic_viscosity: '運動黏度',
      specific_heat: '比熱',
      velocity: '速度',
      pressure: '壓力',
      pressure_drop: '壓力損失',
      total_pressure_drop: '總壓損失',
      mass_flow: '質量流量',
      mass_flow_net: '淨質量流量',
      volumetric_flow: '體積流量',
      temperature: '溫度',
      temperature_max: '最高溫度',
      temperature_min: '最低溫度',
      temperature_avg: '平均溫度',
      ambient_temperature: '環境溫度',
      initial_temperature: '初始溫度',
      temperature_difference: '溫度差',
      thermal_conductivity: '熱傳導率',
      film_coefficient: '薄膜傳熱係數',
      heat_rate: '熱流率',
      heat_rate_net: '熱流率收支',
      heat_flux: '熱通量',
      force: '力',
      drag_force: '阻力',
      lift_force: '升力',
      force_net: '淨力',
      preload_force: '預載力',
      displacement: '位移',
      von_mises_stress: '馮米塞斯應力',
      yield_strength: '降伏強度',
      bearing_stress: '承壓應力',
      bending_stress: '彎曲應力',
      biot_number: '畢歐數',
      colburn_factor: '科爾本因子',
      drag_coefficient: '阻力係數',
      dynamic_pressure: '動壓',
      effectiveness: '熱交換效率',
      first_cell_height: '第一層網格高度',
      hydraulic_diameter: '水力直徑',
      frequency: '頻率',
      friction_factor: '摩擦因子',
      friction_velocity: '摩擦速度',
      lift_coefficient: '升力係數',
      loss_coefficient: '損失係數',
      nusselt_number: '努塞爾數',
      pumping_power_ratio: '泵送功率比',
      reynolds_number: '雷諾數',
      safety_factor: '安全係數',
      shear_stress: '剪應力',
      skin_friction_coefficient: '表面摩擦係數',
      slenderness_ratio: '細長比',
      stress: '應力',
      thermal_resistance: '熱阻',
      thermal_time_constant: '熱時間常數',
      time_period: '分析時間',
      volumetric_heat_density: '體積發熱密度',
      temperature_change: '相對初始溫度的溫度變化',
      thickness: '厚度',
      length: '長度',
      angle_of_attack: '攻角',
      prandtl: '普朗特數',
      elastic_modulus: '彈性模數',
      buckling_load: '臨界挫屈載重',
      buckling_load_factor: '挫屈載重係數',
      second_moment_area: '截面二次矩',
      section_modulus: '截面模數',
      moment: '力矩',
      stiffness_fraction: '接頭剛度比',
      friction_coefficient: '摩擦係數',
      stanton_number: '斯坦頓數',
      wall_distance_ratio: '壁面距離比',
    },
  },
  generatedHandCalc: {
    exportSelectionTitle: '選擇要匯出的計算',
    exportSelectionHelp:
      '報告最多可包含 8 個設計點的計算，共 32 列比較及 32 筆參考資料。請選擇設計點，或不含即時計算匯出。所有求解器結果仍會包含，工作階段的編輯內容也會保留。',
    exportSelectionLimit:
      '請減少至最多 8 個設計點、32 列比較及 32 筆參考資料。',
    exportRowCount: '{{count}} 列比較',
    exportSelected: '匯出所選計算',
    exportWithoutCalculations: '不含即時計算匯出',
    cancel: '取消',
    notGenerated: '此執行沒有已儲存的手算。請開啟設計點以建立。',
    liveOnly: '設計點已儲存的手算，針對此次執行重新呈現。',
    reportTitle: '手算比較',
    assumptions: '假設',
    cause: '原因：{{text}}',
    empty: '此執行所陳述的內容不足以建立任何收支。',
    dropped: {
      unresolved_target_one:
        '{{count}} 個邊界條件無法對應到部件,因此未納入任何收支',
      unresolved_target_other:
        '{{count}} 個邊界條件無法對應到部件,因此未納入任何收支',
      contact_pair_one: '{{count}} 組接觸對無法對應到部件',
      contact_pair_other: '{{count}} 組接觸對無法對應到部件',
      tied_interface_one: '{{count}} 組黏合面無法對應到部件',
      tied_interface_other: '{{count}} 組黏合面無法對應到部件',
      missing_end_one: '{{count}} 條線指向圖上不存在的部件',
      missing_end_other: '{{count}} 條線指向圖上不存在的部件',
      duplicate_fact_one:
        '同一部件有 {{count}} 筆數值以無法相加的單位重複記載,因此只顯示第一筆',
      duplicate_fact_other:
        '同一部件有 {{count}} 筆數值以無法相加的單位重複記載,因此各只顯示第一筆',
      over_scope_limit_one:
        '此組件超出單一回應可承載的範圍:缺少 {{count}} 個部件或邊界,連同其收支',
      over_scope_limit_other:
        '此組件超出單一回應可承載的範圍:缺少 {{count}} 個部件或邊界,連同其收支',
      over_fact_limit_one: '{{count}} 筆記錄的數值無法納入此回應',
      over_fact_limit_other: '{{count}} 筆記錄的數值無法納入此回應',
      over_relation_limit_one:
        '{{count}} 筆收支無法納入此回應，因此其所屬部件未列出',
      over_relation_limit_other:
        '{{count}} 筆收支無法納入此回應，因此其所屬部件未列出',
    },
    unavailable: '此執行不會建立任何收支。',
    gaps: '收支未能平衡之處',
    gapTerms: '最大流入 {{inbound}}，最大流出 {{outbound}}',
    gapTotals: '全部 {{count}} 項合計：流入 {{inbound}}，流出 {{outbound}}',
    difference: '全部流入減去全部流出',
  },

  workbench: {
    // ENG-1843 — 導覽列撤除後保留的鍵:比較與統計介面自身的字串,
    // 以及共用 `ExportReportButton` 使用的 `exportPdf*`。
    compare: '比較',
    compareTitle: '已選取 {{n}} 個設計點',
    compareClose: '返回表格',
    comparePageLabel: '執行結果比較',
    compareClear: '清除比較選取',
    compareNeedsTwo:
      '請選取至少兩個已完成的執行以進行比較 — 可從上方選單，或表格的比較欄位選取。',
    comparePickSlot: '比較對象 {{letter}}',
    comparePickAdd: '加入設計點',
    comparePickRemove: '將 {{letter}} 移出比較',
    compareOutputs: '輸出(相對 A 的差異)',
    compareInputsDiffer: '有差異的輸入',
    compareInputsIdentical:
      '比較的設計點之間所有輸入完全相同 — 求解器、網格與邊界條件皆一致。',
    compareInputsNoneShown:
      '比較的設計點之間,單一數值的輸入沒有差異。求解器參數等巢狀設定不在此比較,仍可能有所不同。',
    compareInput: '輸入',
    compareViewers: '結果檢視',
    compareLinkCameras: '連動檢視',
    compareSyncColourScale: '同步色階',
    compareSyncField: '同步場量',
    compareSyncProbe: '同步線探針',
    compareSyncSectionPlane: '同步剖面',
    compareResiduals: '收斂',
    compareRun: '執行 {{letter}}',
    residualsLoading: '正在載入殘差…',
    residualsUnavailable: '比較的執行沒有殘差歷史。',
    statsTitle: '各輸出在已完成執行間的分布',
    statsNumbers: '數值',
    statsDistribution: '分布',
    distributionStrip: '{{n}} 個可用點的 {{label}}',
    distributionMean: '平均',
    distributionPoint: '設計點 #{{n}} · {{value}}',
    statsEmpty: '尚無含輸出的已完成執行。',
    statsExcluded_one: '基於 {{count}} 個可用點計算 — 已排除 {{ids}}。',
    statsExcluded_other: '基於 {{count}} 個可用點計算 — 已排除 {{ids}}。',
    statsReviewFailures: '查看失敗',
    output: '輸出',
    min: '最小',
    mean: '平均',
    max: '最大',
    spread: '離散度(σ)',
    exportPdf: '匯出報告(PDF)',
    exportPdfPending: '正在準備 PDF…',
    exportDocxPending: '正在準備 Word 文件…',
    exportPdfHint: '編譯不含撰寫內容的表格與檢查項目,並下載為 PDF。',
    exportWriteup: '匯出撰寫內容(PDF)',
    exportWriteupHint: '僅下載撰寫內容,不含表格與檢查項目。',
    exportWriteupDocx: '匯出撰寫內容(Word)',
    exportWriteupDocxHint:
      '僅下載撰寫內容為可編輯的 Word 文件, 不含表格與檢查項目。',
    exportWriteupMenu: '匯出',
    pdfFormat: 'PDF',
    docxFormat: 'DOCX',
    retryExportFormat: '重試 {{format}}',
    exportFormatReady: '{{format}} 已準備完成。',
    exportFormatFailed: '無法準備 {{format}}。請選取以重試。',
    closeReportWriter: '關閉報告撰寫工具',
  },
  aiRetry: {
    regionLabel: 'AI 重試做了什麼',
    title: 'AI 重試從 {{total}} 個失敗的執行中救回 {{count}} 個。',
    titleNone: 'AI 重試沒有救回 {{total}} 個失敗執行中的任何一個。',
    subline_one: '{{points}} 之所以出現在結果中，是因為 AI 重試了它。',
    subline_other: '{{points}} 之所以出現在結果中，是因為 AI 重試了它們。',
    sublineNone: '以下是 AI 嘗試過的內容。',
    show: '顯示 AI 做了什麼',
    hide: '隱藏 AI 做了什麼',
    stateRecovered: '在第 {{n}} 次嘗試救回',
    stateRetrying: '重試中 — 第 {{n}} 次，共 {{max}} 次',
    stateRetryingNoMax: '重試中 — 第 {{n}} 次嘗試',
    stateGaveUp: 'AI 在第 {{n}} 次嘗試後停止，共 {{max}} 次',
    stateGaveUpNoMax: 'AI 在第 {{n}} 次嘗試後停止',
    stateDeclined: 'AI 沒有重試',
    ago: '{{ago}}前',
    justNow: '剛剛',
    footer: '這個研究的每一次 AI 重試，最新的在前。',
  },
  unusableRuns: {
    regionLabel: '沒有可用結果的執行',
    title: '{{total}} 個設計點中有 {{count}} 個沒有產生可用結果。',
    outcomeCancelled: '已取消',
    outcomeUnfinished: '未完成',
    outcomeRunning: '執行中',
    collapse: '摺疊',
    expand: '展開',
    rowExpand: '顯示 AI 對設計點 {{n}} {{label}} 做了什麼',
    rowCollapse: '隱藏設計點 {{n}} {{label}} 的重試細節',
    noRunToAmend: '沒有可重試的執行',
  },
  retryChat: {
    chatTooltip: '就這次失敗詢問重試顧問',
    chatAction: '詢問顧問',
    chatAria: '就設計點 {{n}} {{label}} 的失敗進行對話',
    chatPrompt:
      '研究 {{studyId}} 的設計點 #{{n}} ({{label}}) 沒有產生可用結果。請讀取設計點 {{dpId}} 的輸入、求解器設定與日誌，告訴我它為何失敗以及你會如何調整。',
    chatSessionTitle: '重試建議 — {{label}}',
    retryTooltip: '讓 AI 修改設定並重新執行這個點',
    retryAria: '用 AI 重試設計點 {{n}} {{label}}',
    retryAnywayAria: '以相同設定重試設計點 {{n}} {{label}}',
  },
  sandbox: {
    noCompleted: '尚無可讀取訊號的已完成執行.',
    failedHandCalc:
      '此執行在完成前停止。與執行結果比較的手算需要已完成的結果；請使用下方已記錄的診斷資料調查失敗原因。',
    failedPlottingSubtitle:
      '已停止執行的診斷記錄。這些是部分資料，並非已驗證的結果。',
    dpLabel: '設計點',
    handInputsTitle: '手動輸入 (Hand inputs)',
    solverSignalsTitle: '求解器訊號 (Solver signals)',
    radarTitle: 'L1 自洽性雷達 (L1 self-consistency radar)',
    selfConsistencyTitle: '自洽性檢核',
    plottingTitle: '繪圖組 (Plotting set)',
    plottingSubtitle: 'DOE + 驗證 — 依流態分類與當前支撐來源標記.',
    finalResiduals: '最終殘差',
    wallYplus: '壁 y+',
    internalFlowSignals: '內流訊號',
    min: '最小',
    mean: '平均',
    max: '最大',
    notEmitted: '此執行未輸出.',
    yplusBandsWarning:
      '面積分率 y+ 分區 (<5 / 5–30 / 30–100 / >100) 待 BE 支援 — 僅 min/mean/max 可能掩蓋邊界層覆蓋.',
    legendLive: '已由輸出欄位支撐',
    legendNeedsHand: '需一項手動輸入',
    legendUnderDevelopment: '開發中 (Under development)',
    legendNotEvaluated: '未評估 — 輸入不足 (Not evaluated)',
    visibleTilesLabel: '顯示 {{visible}}/{{total}}',
    visibleTilesHeading: '沙盒圖塊 (Sandbox tiles)',
    showAll: '全部顯示 (Show all)',
    hideAll: '全部隱藏 (Hide all)',
    allTilesHidden: '所有圖塊已隱藏 — 請從上方下拉選單選擇.',
    phase2Stub: '手動輸入與導出量於本分支後續 commit 落地.',
    phase3Stub: '7 軸雷達於本分支後續 commit 落地.',
    phase4Stub: '自洽性表 (FREE / ID / GOOD 標記 + Δ / Δ%) 於後續 commit 落地.',
    tiles: {
      handSolverParity: {
        title: '手算 vs 求解器比較 (hand vs solver comparison)',
        pickerDp: 'DP:',
        desc: '每個量一個點, ±5% 容差以陰影帶呈現. 不必翻表就能回答「沙盒與執行是否一致」.',
        emptyState: '填寫上方手算面板即可產生一致性點.',
        subtitle_one:
          '{{count}} 個量 · 點 = (手算 − 求解器) / 求解器 · ±{{tolerance}}% 為良好 · U 入口速度 · q 動壓 · Q 體積流量 · D 阻力 · C_D 阻力係數',
        subtitle_other:
          '{{count}} 個量 · 點 = (手算 − 求解器) / 求解器 · ±{{tolerance}}% 為良好 · U 入口速度 · q 動壓 · Q 體積流量 · D 阻力 · C_D 阻力係數',
        xAxisLabel: '(手算 − 求解器) / 求解器 (%)',
        yAxisLabel: '求解器 (Solver)',
        yAxisCaption:
          'Y: (手算 − 求解器) / 求解器 (%) — 0 左為偏低, 0 右為偏高',
        tooltipHand: '手算 (Hand)',
        tooltipSolver: '求解器 (Solver)',
        tooltipRatio: '比值 (Ratio)',
        tooltipDp: 'DP',
        chartAriaLabel:
          '手算 vs 求解器比較圖: {{count}} 個量, Y 軸為 Δ%, ±{{tolerance}}% 為良好帶. 形狀: 圓=帶內, 三角=帶外, 叉=超過 15%.',
        rows: {
          u: 'U',
          q: 'q',
          q_flow: 'Q',
          drag: 'D',
          cd: 'C_D',
        },
        rowsFull: {
          u: '入口速度 (Inlet velocity)',
          q: '動壓 (Dynamic pressure)',
          q_flow: '體積流量 (Volumetric flow)',
          drag: '阻力 (Drag force)',
          cd: '阻力係數 (C_D)',
        },
      },
      coeffSettling: {
        title: '係數收斂包絡 (coefficient settling envelope)',
        desc: '最後窗口內的 C_D 與 C_D band. 回答「數值已收斂還是仍在擺盪」.',
      },
      residualHistory: {
        title: '殘差歷程疊圖',
        desc: '全部 DP 疊在同一 log 軸, 發散的執行會從群體中明顯分開.',
        emptyState: '所選 DP 尚未附加模擬.',
      },
      convergenceHistory: {
        title: '收斂歷程',
        desc: '任一記錄量對迭代次數作圖: 最熱固體, 埠口溫度, 質量流量, 介面熱通量. 殘差只說明場還在多快地移動; 這裡顯示場實際在哪裡, 而它可能在殘差已趨平之後仍持續上升.',
        emptyState: '所選 DP 尚未附加模擬.',
      },
      gridConvergence: {
        title: '網格收斂 (Richardson)',
        desc: '回應對網格細化的趨勢與外推 h→0. 標準 V&V 證據.',
        emptyState: '本研究尚未執行 GCI 分析.',
        subtitle: '{{response}} · GCI 細 {{gciFine}}% · 觀測階數 p={{order}}',
        xAxisLabel: '網格尺寸 h (mm) — 粗 → 細',
        extrapLabel: 'h→0',
        tooltipResponse: '回應',
        levelFine: '細',
        levelMedium: '中',
        levelCoarse: '粗',
        levelOther: '層級',
        chartAriaLabel:
          '格網收斂曲線, {{levels}} 個網格層級對 {{response}}. GCI 細 {{gci}}%. X 軸反向 (左粗右細), 虛線為 h→0 外推點.',
      },
      yplusBands: {
        title: 'y+ 覆蓋分區',
        desc: '各 y+ 分區的壁面面積分率. 需 BE 端補足沙盒早已指出的面積分率欄位.',
      },
      carpet: {
        title: '毯圖 (Carpet plot)',
        desc: '將掃描矩陣以熱格呈現 — 速度 × 壓力對一項回應. 依 DOE 建立時的樣貌閱讀.',
        emptyState: '需要各因子 2〜12 個唯一值的二因子掃描.',
        subtitle: '{{yAxis}} × {{xAxis}} → {{response}}',
        emptyAmbiguous:
          '此格點上有多個執行, 一格會有一個以上的答案. 請改選另一組輸入, 或移除重複的執行.',
        emptyCellTooltip: '此輸入組合尚無 DP',
        pickerX: 'X 軸:',
        pickerY: 'Y 軸:',
        pickerZ: '顏色代表:',
        groupResponses: '結果 (Results)',
        chartAriaLabel:
          '毯圖: {{rows}}×{{cols}} 熱格, Y={{yAxis}}, X={{xAxis}}, 色={{response}}.',
      },
      parallelCoords: {
        title: 'X–Y 繪圖器',
        desc: '在 X 與 Y 上任選兩個數值欄位. 每個已完成 DP 一個點. 結果 vs 結果, 結果 vs 輸入, 或 結果 vs DP 編號.',
        emptyState: '至少需要 1 個已完成 DP 與一個數值結果.',
        subtitle: '{{dps}} 個 DP · 每個已完成 DP 一個點',
        pickerX: 'X 軸:',
        pickerY: 'Y 軸:',
        axisTitleHint: '雙擊以輸入欄位名稱',
        groupMeta: '順序 (Order)',
        groupInputs: '輸入 (Inputs)',
        groupResponses: '結果 (Results)',
        optionDpIndex: 'DP 編號 (DP #)',
        tooltipDp: 'DP',
        axisInput: '輸入',
        axisResponse: '結果',
        chartAriaLabel:
          'X–Y 繪圖器: {{dps}} 個 DP, X={{xLabel}}, Y={{yLabel}}.',
      },
      sensitivityTornado: {
        title: '敏感度龍捲風',
        desc: '各輸入在掃描範圍內的回應擺幅. 在既有的敏感度面板上, 於每根實測條後方疊上手算的鬼影條.',
        emptyState: 'Sobol 敏感度尚未計算 — 本研究的分析尚未執行.',
        subtitle: '{{response}} 前 {{count}} 名主要驅動因子 (Sₜ)',
        tooltipSt: 'Sₜ (全階)',
        chartAriaLabel:
          '敏感度龍捲風: {{response}} 前 {{count}} 名驅動因子 (Sₜ). 負值向 0 左側延伸.',
      },
      massBalance: {
        title: '質量收支瀑布圖',
        desc: '進流量、出流量與兩者之差畫在同一基線上. 表格中難以判斷輕重的 5.5e-7 殘差 (相對於進流 0.128), 在這裡是一眼看得出幾乎為零的長條.',
        emptyNoPoints: '尚無已完成的設計點.',
        emptyNoFlow:
          '此設計點沒有可供收支的進出口流量. 有流量的執行在下方清單中不會標記.',
        tooltipFlowLabel: '流量',
        tooltipResidualLabel: '殘差',
        pickerDp: '設計點:',
        noFlowTag: '無流量資料',
        spokenUnits: {
          'm³/s': '每秒立方公尺',
          'kg/s': '每秒公斤',
        },
        srInlet: '進口流量 {{value}} {{unit}}.',
        srOutlet: '出口流量 {{value}} {{unit}}.',
        srResidual: '殘差 {{value}} {{unit}}, 為流量刻度的 {{pct}}%.',
        srRow: '{{name}}: {{value}} {{unit}}.',
        inlet: '進口',
        outlet: '出口',
        chartAriaLabel:
          '質量收支瀑布圖: 進口流量、出口流量與兩者殘差. 殘差為流量刻度的 {{pct}}%.',
      },
    },
  },
  boundaryConditionReview: {
    eyebrow: '邊界條件審查',
    title: '模擬前確認各面片物理設定',
    descriptionHave_one: '{{count}} 個設計點已有網格',
    descriptionHave_other: '{{count}} 個設計點已有網格',
    descriptionWithout: '{{count}} 個尚未產生',
    descriptionRest:
      '。為每個面片指定邊界條件物理（速度入口、壓力出口、壁面、自由流） — 此清單套用至研究中的每個網格。',
    resumeStudy: '繼續研究',
    resumeFailed: '繼續失敗。',
    perPatchTitle: '各面片邊界條件',
    loadingPatches: '正在載入面片…',
    withoutMesh_one: '{{count}} 個設計點尚無網格',
    withoutMesh_other: '{{count}} 個設計點尚無網格',
  },
  decideAnalysis: {
    iterationReview: '第 {{iteration}} 次迭代審查',
    iterationReviewFallback: '迭代審查',
    headerSubtitle: '收斂情形、前緣與建議的下一批取樣點',
    completed: '已完成 {{count}} 個',
    onFrontier: '前緣上有 {{count}} 個',
    hypervolumeTitle: '超體積',
    hypervolumeEmptySubtitle: '尚無已完成的迭代',
    hypervolumeSinglePointSubtitle: '下一次迭代完成後即可繪製軌跡',
    hypervolumeSinglePoint: '第 {{iteration}} 次迭代 • 僅單一資料點',
    hypervolumeSubtitle: '數值越高越好 — 趨於平緩代表報酬遞減',
    hypervolumeLabel: '超體積',
    axisIteration: '迭代',
    changeFromPrevious: '相較前一次迭代的變化',
    paretoTitle: 'Pareto 前緣',
    paretoEmptySubtitle: '第一次迭代完成後即會顯示前緣',
    paretoLabel: 'Pareto 前緣',
    paretoSubtitle_one: '{{count}} 個非支配點 • 點的大小 = HV 貢獻',
    paretoSubtitle_other: '{{count}} 個非支配點 • 點的大小 = HV 貢獻',
    hvContribution: 'HV 貢獻：{{value}}',
    hvContributionOfBest: 'HV 貢獻：{{value}}（為最佳值的 {{pct}}%）',
    bestSoFarTitle: '目前最佳',
    bestSoFarEmptySubtitle: '尚無已完成的執行',
    designPoint: '設計點',
    frontierTableSubtitle:
      '橫跨 {{objectives}} 個目標的 {{count}} 個非支配點 — 依 HV 貢獻排序',
    columnDp: 'DP',
    columnHv: 'HV',
    proposedForIteration: '為第 {{iteration}} 次迭代建議',
    candidatesSummary_one: '{{count}} 個候選點 • 以自然單位呈現 GP 平均預測',
    candidatesSummary_other: '{{count}} 個候選點 • 以自然單位呈現 GP 平均預測',
    acquisition: '取得函數',
    acquisitionTooltip:
      '聯合 qLogNEHVI 值 — 數值越高代表優化器預期此批次帶來更多 HV 增益',
    noPredictions: '此建議未記錄任何預測。',
    columnDesignPoint: '設計點',
  },
  decideReview: {
    optimizerPaused: '優化器已暫停',
    reviewIteration: '繼續前請審查第 {{iteration}} 次迭代',
    reviewIterationFallback: '繼續前請審查此次迭代',
    proposedIntro: '貝氏優化器建議了',
    proposedPoints_one: '{{count}} 個新設計點',
    proposedPoints_other: '{{count}} 個新設計點',
    proposedOutro: '作為下一批次。繼續以派送這些點，或以目前結果停止研究。',
    cancelStudy: '取消研究',
    stopStudy: '停止研究',
    continueIteration: '繼續迭代',
    decisionFailed: '決策失敗。',
  },
  paretoScatter: {
    downloadPng: '下載圖表為 PNG',
    downloadHtml: '下載圖表為獨立互動式 HTML',
    paretoFrontier: 'Pareto 前緣',
    otherCompleted: '其他已完成',
    frontierLegend: 'Pareto 前緣（大小 = HV 貢獻）',
    onFrontier: '位於前緣',
    dominated: '被支配',
    otherResponses: '其他回應',
    designParameters: '設計參數',
    hvContribution: 'HV 貢獻：{{value}}',
    htmlHint: '將游標移至任一點即可查看其設計參數。',
  },
  sensitivity: {
    title: '敏感度',
    subtitle:
      '在擬合代理模型上進行 Sobol 全域敏感度分析 — 各輸入的變異數占比，附拔靴信賴區間',
    trainingRows: '代理模型訓練列數',
    dropped_one: '{{count}} 個設計點因回應不完整而剔除',
    dropped_other: '{{count}} 個設計點因回應不完整而剔除',
    saltelliEvals: '對代理模型進行的 Saltelli 評估',
    bootstrapResamples: '每個指標的拔靴重抽樣次數',
    saltelliSeed: 'Saltelli 種子',
    computedAt: '計算於',
    noIndices: '此回應沒有可用指標',
    s1FirstOrder: 'S₁（一階）',
    stTotalOrder: 'Sₜ（總階）',
    interactionsDominateTooltip:
      '主要驅動因子 {{input}}：其效應有 {{pct}}% 來自交互作用（Sₜ − S₁）',
    interactionsDominate: '交互作用主導',
    columnInput: '輸入',
    deltaTooltip: 'Sₜ − S₁ — 涉及此輸入的交互作用所占變異數比例',
    varianceShare: '變異數占比',
    interactionsDelta: '交互作用 Δ {{value}}',
  },
  surrogateValidation: {
    title: '代理模型驗證',
    subtitle: '留一法診斷 — 在擬合 GP 上比較預測值與實際值',
    iteration: '第 {{iteration}} 次迭代',
    completed: '已完成 {{count}} 個',
    logSpaceTooltip: '代理模型於對數空間擬合；顯示的數值已轉回自然單位',
    logSpaceFit: '對數空間擬合',
    parityTitle: '對等圖',
    paritySubtitle: '預測值與實際值 — 緊貼 y = x 代表 GP 可信',
    learningCurveTitle: '學習曲線',
    learningCurveSubtitle: '各迭代的 RMSE — 隨代理模型收斂而趨於平緩',
    r2Tooltip: 'GP 代理模型的留一法 R²',
    coverageLabel: '95% 覆蓋率',
    coverageTooltip: '落在 ±2σ 內的留一法真值比例 — 應接近 0.95',
    axisActual: '實際值',
    axisPredicted: '預測值',
    axisIteration: '迭代',
    tooltipActual: '實際值：{{value}}',
    tooltipPredicted: '預測值：{{value}} ± {{err}}',
    tooltipResidual: '殘差：{{value}}',
    singlePoint:
      '第 {{iteration}} 次迭代 • 僅單一資料點 — 下一次迭代完成後即會顯示軌跡',
  },
  simError: {
    hideDetails: '隱藏詳細資訊（{{count}} 行）',
    showDetails: '顯示詳細資訊（{{count}} 行）',
    configErrorLine: '設定錯誤 · {{kind}}',
    foamFatalTitle: 'OpenFOAM 致命錯誤',
    solverDivergedTitle: '求解器發散',
    divergedIteration: '第 {{step}} 次迭代',
    divergedUnknownIteration: '某次未知的迭代',
    divergedResidual: '某個殘差',
    divergedIntro: '殘差於 {{step}} 超出數值範圍（NaN/Inf）。',
    divergedFieldNonFinite: '欄位率先變為非有限值。',
    commonCauses: '常見原因（最可能 → 最不可能）',
    causeFirstLayerSst:
      '首層網格對 k-ω SST 而言過薄 — 壁面附近需 y+ < 5；請以更緊密的邊界層重新產生網格。',
    causeFirstLayerRas:
      '首層網格對所選流動類型而言過薄。使用紊流模型時對壁面解析度特別敏感。',
    causeInletVelocity:
      '入口速度相對於網格解析度過高（穩態求解器中類似 CFL 的不穩定）。',
    causeBadMesh: '壁面附近網格不良 — 負體積網格。請查看網格頁面的品質報告。',
    causeRelaxation:
      '鬆弛因子過強。請在求解器 → 進階中降低壓力與速度的鬆弛因子（建議：壓力 ≤ 0.2、速度 ≤ 0.5）。',
    pressureSolveTitle: '求解器在壓力求解階段崩潰',
    pressureSolveIntro:
      '於 {{step}} 發生浮點錯誤 — 通常是壓力求解器在低品質網格上失效。',
    thingsToTry: '可嘗試的做法',
    tryPcg: '切換至 PCG / PBiCGStab，位於',
    trySolverPExposed: '（若有開放）。',
    tryOneRegion: '確認網格僅含一個連通的流體區域（見網格品質報告）。',
    tryReduceRelaxPPre: '將',
    tryReduceRelaxPPost: '降至 0.1 執行一次作為診斷。',
    chtFailedTitle: 'CHT 求解器失敗',
    chtIntro:
      '共軛熱傳需要多區域網格 — 且 CHT 邊界條件的結構描述與 external_flow 不同。',
    chtPitfalls: '常見 CHT 陷阱',
    chtElementType: '網格必須以 element_type 產生：',
    chtElementTypePost: '並且至少有一個對應流體/固體介面的 face_tag。',
    chtBoundaryConditionsPost: '必須包含對應流體區域的 FluidInletThermalBC。',
    chtSolidBcs:
      '固體邊界條件使用 face_id（網格標記），而非面片名稱 — 與 external_flow 的結構描述不同。',
    diagnosisFieldLabel: '要修改的輸入',
    evidenceLabel: '實測值',
    evidenceContactPairs: '要求的接觸對數',
    evidenceContactElements: '形成的接觸元素數',
    evidenceIterations: '記錄的疊代次數',
    evidenceResidualTrend: '殘差',
    residualTrend: {
      falling: '仍在下降',
      flat: '持平',
      oscillating: '震盪',
    },
    genericExitTitle: '求解器以代碼 {{code}} 結束',
    genericExitBody:
      '此次執行未擷取到結構化的失敗細節。請檢查原始求解器記錄以進行診斷。',
    preflightTitle: '無法提交研究',
    hints: {
      foamFatal: {
        patchFieldMissing:
          '網格中存在此面片，但未為其設定邊界條件。請為缺少的面片新增一筆 boundary_conditions 項目。',
        unknownPatchType:
          '面片類型不符 — 某個 face_tags 標籤可能已被淨化為保留名稱。請在 MeshGen 的 Boundary Assignment 中重新命名該標籤。',
        keywordUndefined:
          'OpenFOAM 案例字典中缺少必要欄位 — 很可能是後端錯誤。請回報。',
        polyMeshMissing:
          '網格上傳不完整或已損毀。請重新為幾何產生網格並重新執行。',
      },
      config: {
        bcPatchMismatchTitle: '面片名稱與網格不符',
        bcPatchMismatchHint:
          'boundary_conditions 參照了網格 polyMesh 中不存在的面片。請開啟 BC 編輯器並檢查名稱 — meshgen 常在標籤前加上 `body_`，或針對多面標籤將一個標籤拆分為 `_000` / `_001`。',
        meshInvalidTitle: '網格檔案無法讀取',
        meshInvalidHint:
          '所選網格載入失敗（polyMesh 損毀、檔案缺失或格式不支援）。請從 MeshGen 重新為幾何產生網格並重新提交。',
        bcMissingInletTitle: '未定義速度來源',
        bcMissingInletHint:
          '外部流研究至少需要一個具備速度的邊界條件（速度入口或自由流）的面片。請開啟 BC 編輯器並設定一個。',
        bcMissingOutletTitle: '未定義出口',
        bcMissingOutletHint:
          '請至少將一個面片設為壓力出口（外部空氣動力學則設為自由流）。若缺少固定壓力的邊界條件，壓力方程式將無界，求解器會在第一次迭代時發散。',
        bcInterfaceReservedTitle: '流固介面面片被重新指派',
        bcInterfaceReservedHint:
          '其中一個邊界條件指向內部的流固介面面片（`<a>_to_<b>`）。這些面片由能量耦合自動管理，無法重新指定角色。請移除該列，並在真正的邊界面片上重新選擇壁面/入口/出口。',
        unknownTitle: '設定錯誤',
      },
      preflight: {
        noInletVelocityTitle: '未設定入口速度',
        noInletVelocityFix:
          '入口速度不可為 0。在步驟 3 → 邊界條件中，將一個面片設為「速度入口」或「自由流」並指定非零速度。',
        bcMissingTitle: '缺少邊界條件',
        bcMissingFix:
          '在步驟 3 → 邊界條件中，為每個網格面片指定物理設定（入口、出口、壁面等）。',
        turbulentLengthScaleTitle: '未設定紊流長度尺度',
        turbulentLengthScaleFix:
          '在求解器設定 → 紊流中，將長度尺度設為物體特徵長度的約 7~10%。',
        manualDpStaleInputTitle: '手動設計點指向已未被選取的輸入',
        manualDpStaleInputFix:
          '移除預覽中標紅框的手動設計點，或重新選取其對應的網格/幾何後再執行。',
      },
    },
  },
} as const;
